<template>
  <div class="asc-page-fixed-footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AscPageFixedFooter',
}
</script>

<style lang="scss">
.asc-content-wrapper--container {
  .asc-page-fixed-footer {
    height: 48px;
    background-color: $gray-300;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);
    position: fixed;
    z-index: 10;
    bottom: 0;
    padding: 8px 19px;
  }

  $asc-primary-navbar-container-width-full: $primary-navbar-width;
  $asc-primary-navbar-container-width-collapsed: 48px;
  $asc-container-padding: 32px;
  $scroll-width: 8px;

  /* stylelint-disable */
  &.full {
    .asc-page-fixed-footer {
      width: calc(
        100% - #{$asc-primary-navbar-container-width-full} - #{$asc-container-padding} -
          #{$scroll-width}
      );
    }
  }

  &.collapsed {
    .asc-page-fixed-footer {
      width: calc(
        100% - #{$asc-primary-navbar-container-width-collapsed} - #{$asc-container-padding} -
          #{$scroll-width}
      );
    }
  }
}
</style>
